<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="username" label="账号" width="180">
      </el-table-column>
      <el-table-column prop="password" label="密码" width="180">
      </el-table-column>
      <el-table-column prop="nickname" label="昵称">
      </el-table-column>
      <el-table-column prop="hospital" label="医院">
      </el-table-column>
      <el-table-column prop="department" label="科室">
      </el-table-column>
      <el-table-column prop="note" label="备注">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="page" background layout="total, prev, pager, next" :page-count="total" :current-page="pageNum"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import global from '../Global';
  export default {
    name: 'allTempUser',
    data() {
      return {
        tableData: [],
        total: 20,
        pageNum: 1
      }
    },
    mounted() {
      this.getAllTmpUser(1);
    },
    methods: {
      getAllTmpUser(pageNum) {
        this.pageNum = pageNum;
        let that = this;
        that.axios({
          method: 'GET',
          url: global.accountUrl + '/storkUser/getAllTmpUser?pageNum=' + pageNum + '&pageSize=8'
        })
          .then(function (response) {
            if (response.data.code == 200) {
              that.tableData = response.data.data.data;
              that.total = response.data.data.total;
            }
            else {
              that.$message.error('请求数据失败');
            }
          })
      },
      handleCurrentChange(pageNum) {
        this.getAllTmpUser(pageNum);
      },
      handleClick(row) {
        let that = this;
        this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios({
            method: 'POST',
            url: global.accountUrl + '/storkUser/delTmpUser?username=' + row.username
          })
            .then(function (response) {
              if (response.data.code == 200) {
                that.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                that.getAllTmpUser(that.pageNum);
                console.log(that.pageNum);
              }
              else {
                that.$message({
                  type: 'info',
                  message: '删除失败!'
                });
              }
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  }
</script>

<style>
  .page {
    width: 400px;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/tempuser/AllTempUser.vue